const WorkInProgressComponent = () =>
  import('@/views/wip/WorkInProgressComponent')
const TheContactIndexPage = () =>
  import('@/views/contact/TheContactIndexPage.vue')
const TheContactViewPage = () =>
  import('@/views/contact/TheContactViewPage.vue')

export const contactsRootPages = {
  path: 'contacts',
  name: 'contacts_route',
  component: WorkInProgressComponent
}

export const contactsSubPages = [
  {
    path: 'contacts/address-book',
    name: 'address_book_page_route',
    component: TheContactIndexPage
  },
  {
    path: 'contact/:contactId',
    name: 'contact_view_route',
    component: TheContactViewPage,
    props: (route) => {
      return {
        type: 'contact',
        ...route.params
      }
    }
  }
]
